import {
  Appointment,
  AppointmentsGroupBy,
  DotFitter,
  Fitter,
  Score,
  TimeFilters,
} from '@sc/data-access-models';
import { Observable } from 'rxjs';

export type AgregatedAppointments = Map<string, Map<string, Appointment[]>>;

export type FilterFunc<T> = (inputTab: T[]) => T[];

export type SearchStatus =
  | 'WAITING'
  | 'SEARCHING'
  | 'SUCCESS'
  | 'ERROR'
  | 'NO_APPOINTMENTS';

export type SearchSlotsError = 'TIMEOUT' | 'NO_APPOINTMENT' | 'ERROR';

export type FitterSortStrategy = 'score-dist' | 'dist-score';

export interface PrimaryFilters {
  appointmentsFilter: FilterFunc<Appointment>;
  fittersFilter: FilterFunc<Fitter>;
  dotFittersFilter: FilterFunc<DotFitter>;
  scoresFilter: FilterFunc<Score>;
}

export interface InputObservables {
  appointmentMap: Observable<AppointmentsGroupBy>;
  inCenter: Observable<boolean>;
  atHome: Observable<boolean>;
  replacementVehicle: Observable<boolean>;
  timeFilter: Observable<TimeFilters | null>;
  generalists: Observable<boolean>;
  specialist: Observable<boolean>;
  sortStrategy: Observable<FitterSortStrategy>;
}

export interface AppointmentSubParams {
  checkCutOffs: boolean;
  checkMobility: boolean;
  checkReplacementVehicle: boolean;
  removeDuplicates: boolean;
  fetchSlotsTimeout: number;
  maxCachedMobileCoords: number;
  maxCachedMobileApmtByCoord: number;
}

export interface AppointmentSubErrorSnackbarTextKeys {
  titleKey: string;
  bodyKey: string;
}
